export default {
  contentTypes: {
    module: "CModule",
    topic: "CTopic",
    part: "CPart",
    keyTerm: "CKeyTerm",
    activity: "CActivity",
    page: "CPage",
    languages: "CLanguage",
    configuration: "CConfig",
  },

  sections: {
    waterfall: "PMWaterfall",
    agile: "PMAgile",
  },
  prodHostName: "kickoff.pmi.org",
  socialPlatforms: {
    facebook: "facebook",
    linkedin: "linkedin",
    twitter: "twitter",
  },
};
